import React from 'react';
import handleViewport from 'react-in-viewport';
import styled from 'styled-components';
import { Segment, Message, Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import util from 'utils/utils';

// eslint-disable-next-line no-unused-vars
const StyledSegment = styled(({ sectionInclude, ispreview, ...others }) => <Segment {...others} />)`
  ${props => (props.sectionInclude ? `
    border: none !important;
    color: white;
    background-color: ${util.adjustColour(props.sectionInclude.colour, -0.08)} !important;
  ` : '')}
  ${props => props.ispreview && 'border: none !important;'}
`;

function SectionHeader(props) {
  const {
    section, sectionInclude, isEditing, t, isPreview,
  } = props;
  if (sectionInclude) {
    return (
      <StyledSegment raised attached="top" sectionInclude={sectionInclude} ispreview={isPreview ? 1 : 0}>
        <h3>
          {sectionInclude.title}
        </h3>
        {isEditing && sectionInclude.description
          && <p style={{ display: 'inline-flex' }}>{t(`ideas.6Cs.sections.${sectionInclude.key}.description`)}</p>
        }
      </StyledSegment>
    );
  }
  return (
    <StyledSegment raised attached="top" ispreview={isPreview}>
      <h3>{section.name}</h3>
      {section.type === 'edi'
        && (
        <Message success>
          <Message.Header>
            <Icon name="lock" />
            {' '}
            This section is about equality, diversity, and inclusion
          </Message.Header>
          <Message.Content>Your information here is protected and is only available to select challenge administrators.</Message.Content>
        </Message>
        )
      }
    </StyledSegment>
  );
}

export default withTranslation()(handleViewport(SectionHeader, { threshold: 1 }));
